import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  container: {flex: 1, alignItems: 'center', justifyContent: 'flex-end', paddingBottom: '40%'},
});

export default styles;
